const ALLOWED_REDIRECT_PREFIXES = ['/admin', '/onboard'];
const BLOCKED_AUTH_PATHS = ['/admin/signin', '/admin/signup', '/admin/forgotpassword', '/admin/resetpassword'];

const SIGN_IN_PATH = '/admin/signin';

const isSafePath = (path: string): boolean => {
  if (!path.startsWith('/') || path.startsWith('//')) {
    return false;
  }

  if (!ALLOWED_REDIRECT_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return false;
  }

  return !BLOCKED_AUTH_PATHS.some((blockedPath) => path === blockedPath || path.startsWith(`${blockedPath}/`));
};

export const safeRedirect = (rawReturnTo?: string | null): string | null => {
  if (!rawReturnTo) {
    return null;
  }

  const decodedReturnTo = (() => {
    try {
      return decodeURIComponent(rawReturnTo);
    } catch (_error) {
      return rawReturnTo;
    }
  })().trim();

  if (!decodedReturnTo) {
    return null;
  }

  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(decodedReturnTo)) {
    return null;
  }

  try {
    const parsedUrl = new URL(decodedReturnTo, 'http://localhost');
    const normalizedPath = parsedUrl.pathname;

    if (!isSafePath(normalizedPath)) {
      return null;
    }

    return `${normalizedPath}${parsedUrl.search}${parsedUrl.hash}`;
  } catch (_error) {
    return null;
  }
};

export const getSafeReturnToFromSearch = (search: string): string | null => {
  if (!search) {
    return null;
  }

  const returnTo = new URLSearchParams(search).get('returnTo');
  return safeRedirect(returnTo);
};

export const buildSignInRedirectUrl = (pathname: string, search = '', hash = ''): string => {
  const currentUrl = `${pathname}${search}${hash}`;
  return `${SIGN_IN_PATH}?returnTo=${encodeURIComponent(currentUrl)}`;
};
